import React, { useState, useEffect } from "react"
import { Input, Label, FormGroup, Button, Card, CardTitle, CardBody, CardText, CardHeader, CardFooter, Row, Col, Form } from "reactstrap"

import jwt from "jsonwebtoken"

const apiUrl = "https://admin.idexo.io/"

const Admin = () => {
    const [isLoading, setIsLoading] = useState(false)

    const [activeUser, setActiveUser] = useState(null)
    const [emailInput, setEmailInput] = useState("")

    // show inputs

    const [editPaid, setEditPaid] = useState(false)
    const [editBalance, setEditBalance] = useState(false)
    const [editApi, setEditApi] = useState(false)
    const [editOrigin, setEditOrigin] = useState(false)

    // update inputs
    const [apiInput, setApiInput] = useState("")
    const [paidInput, setPaidInput] = useState("")
    const [balanceInput, setBalanceInput] = useState("")
    const [originInput, setOriginInput] = useState("")

    const [userNotFound, setUserNotFound] = useState(false)

    useEffect(() => {
        let output = document.getElementById("output")
        if (activeUser) {
            output.innerText = JSON.stringify(activeUser, null, 4)
        }
        return () => {
            output.innerText = ""
        }
    }, [activeUser])

    const handleEdit = (attribute) => {
        switch (attribute) {
            case "paid":
                setEditPaid(!editPaid)
                break
            case "api":
                setEditApi(!editApi)
                break
            case "origin":
                setEditOrigin(!editOrigin)
                break
            case "balance":
                setEditBalance(!editBalance)
                break

            default:
                break
        }
    }

    const handleSubmit = async (attribute) => {
        let value
        switch (attribute) {
            case "paid":
                value = paidInput
                setPaidInput("")
                setEditPaid(false)
                await setPaid(value)
                break
            case "origin":
                value = originInput
                setOriginInput("")
                setEditOrigin(false)
                await setOrigin(value)
                break
            case "balance_add":
                value = balanceInput
                if (Number(value) < 0) {
                    value = Math.abs(value)
                }
                setBalanceInput("")
                setEditBalance(false)
                await updateBalance(value)
                break
            case "balance_sub":
                value = balanceInput
                if (Number(value) > 0) {
                    value = Number(value) * -1
                }
                setBalanceInput("")
                setEditBalance(false)
                await updateBalance(value)
                break
            case "api":
                value = apiInput
                setApiInput("")
                setEditApi(false)
                await setApikey(value)
                break

            default:
                break
        }
    }

    const getUser = async (email) => {
        setActiveUser(null)
        setIsLoading(true)
        await fetch(apiUrl + "?path=user&email=" + encodeURIComponent(email), {
            headers: { token: localStorage.jwtToken }
        })
            .then((res) => res.json())
            .then((data) => {
                if (data.error) {
                    alert("Things are not going your way, server says: " + data.error)
                } else if (data.data.Count === 0) {
                    setUserNotFound(true)
                    alert("No user matches your search...")
                } else {
                    setActiveUser(data.data.Items[0])
                    console.log(JSON.stringify(data.data.Items, null, 4))
                }
            })
            .catch((error) => {
                console.log(error)
            })
            .finally(setIsLoading(false))
    }

    const getBalanceHistory = (event) => {
        setIsLoading(true)
        if (activeUser) {
            let output = document.getElementById("output")
            output.innerText = ""
            fetch(apiUrl + "?path=balance&user_id=" + encodeURIComponent(activeUser.id.S), {
                headers: { token: localStorage.jwtToken }
            })
                .then((res) => res.json())
                .then((data) => {
                    if (data.error) {
                        alert("Things are not going your way, server says: " + data.error)
                    } else if (data.data.Count == 0) {
                        alert("No data found...")
                    } else {
                        console.log(JSON.stringify(data.data, null, 4))
                        output.innerText = JSON.stringify(data.data, null, 4)
                    }
                })
                .catch((error) => {
                    console.log(error)
                })
                .finally(setIsLoading(false))
        }
    }

    const setOrigin = async (newValue) => {
        setIsLoading(true)
        if (activeUser) {
            fetch(apiUrl + "?path=user&action=origin", {
                method: "POST",
                headers: { token: localStorage.jwtToken },
                body: JSON.stringify({
                    email: activeUser.email.S,
                    origin: newValue
                })
            })
                .then((res) => res.json())
                .then((data) => {
                    if (data.error) {
                        alert("Things are not going your way, server says: " + data.error)
                    } else {
                        console.log(JSON.stringify(data.data.Attributes, null, 4))
                        getUser(emailInput)
                    }
                })
                .catch((error) => {
                    console.log(error)
                })
                .finally(setIsLoading(false))
        }
    }

    const setPaid = async (newValue) => {
        setIsLoading(true)
        if (activeUser) {
            fetch(apiUrl + "?path=user&action=paid", {
                method: "POST",
                headers: { token: localStorage.jwtToken },
                body: JSON.stringify({
                    email: activeUser.email.S,
                    paid: newValue
                })
            })
                .then((res) => res.json())
                .then((data) => {
                    if (data.error) {
                        alert("Things are not going your way, server says: " + data.error)
                    } else {
                        console.log(JSON.stringify(data.data.Attributes, null, 4))
                        getUser(emailInput)
                    }
                })
                .catch((error) => {
                    console.log(error)
                })
                .finally(setIsLoading(false))
        }
    }

    const setApikey = async (newValue) => {
        setIsLoading(true)
        if (activeUser) {
            fetch(apiUrl + "?path=user&action=apikey", {
                method: "POST",
                headers: { token: localStorage.jwtToken },
                body: JSON.stringify({
                    email: activeUser.email.S,
                    apikey: newValue
                })
            })
                .then((res) => res.json())
                .then((data) => {
                    if (data.error) {
                        alert("Things are not going your way, server says: " + data.error)
                    } else {
                        console.log(JSON.stringify(data.data.Attributes, null, 4))
                        getUser(emailInput)
                    }
                })
                .catch((error) => {
                    console.log(error)
                })
                .finally(setIsLoading(false))
        }
    }

    const updateBalance = async (amount) => {
        setIsLoading(true)
        if (activeUser && Number(amount) !== 0) {
            let prefix
            let decoded = jwt.decode(localStorage.jwtToken)
            amount > 0 ? (prefix = "add") : (prefix = "sub")
            fetch(apiUrl + "?path=balance", {
                method: "POST",
                headers: { token: localStorage.jwtToken },
                body: JSON.stringify({
                    email: activeUser.email.S,
                    user_id: activeUser.id.S,
                    method: `${prefix}_by_admin_${decoded.email}`,
                    amount: amount
                })
            })
                .then((res) => res.json())
                .then((data) => {
                    if (data.error) {
                        alert("Things are not going your way, server says: " + data.error)
                    } else {
                        console.log(JSON.stringify(data.data, null, 4))
                        getUser(emailInput)
                    }
                })
                .catch((error) => {
                    console.log(error)
                })
                .finally(setIsLoading(false))
        }
    }

    return (
        <div className="admin-page">
            <Card body>
                <CardTitle tag="h3">Search User</CardTitle>
                <Form onSubmit={(e) => e.preventDefault()}>
                    <FormGroup>
                        <Label for="email">Email:</Label>
                        <Input
                            id="email"
                            type="email"
                            value={emailInput}
                            disabled={isLoading}
                            onChange={(e) => {
                                setActiveUser(null)
                                setUserNotFound(false)
                                setEmailInput(e.target.value)
                            }}
                        />
                    </FormGroup>
                    {/*
                 TODO: implement search by ID and apiKey
                        */}
                    {/* <FormGroup>
                        <Label for="id">User Id:</Label>
                        <Input id="id" type="text" />
                    </FormGroup>
                    <FormGroup>
                        <Label for="api">Api Key:</Label>
                        <Input id="api" type="text" />
                    </FormGroup> */}
                </Form>
                <Row className="align-content-center justify-content-center">
                    <Button
                        color="primary"
                        className="mt-2 w-50"
                        onClick={() => getUser(emailInput)}
                        disabled={emailInput.trim().length === 0 || isLoading}
                    >
                        Search
                    </Button>
                </Row>
                {userNotFound ? (
                    <Card className="mt-3" body>
                        <CardTitle tag="h3">Message</CardTitle>
                        {/* <CardBody>{JSON.stringify(activeUser, null, 4)}</CardBody> */}
                        <CardBody>
                            <CardText tag="h4" color="danger">
                                User Not Found...
                            </CardText>
                        </CardBody>
                    </Card>
                ) : null}
                {isLoading ? (
                    <Card className="mt-3" body>
                        Is Loading...
                    </Card>
                ) : activeUser ? (
                    <Card className="mt-3" body>
                        <CardTitle tag="h3">Active User Details</CardTitle>
                        <CardBody>
                            <CardText tag="h4">
                                <strong>User Type: </strong>
                                {activeUser.type.S}
                            </CardText>
                        </CardBody>
                        <CardBody>
                            <CardText tag="h4">
                                <strong>Email: </strong>
                                {activeUser.email.S}
                            </CardText>
                        </CardBody>

                        <CardBody>
                            <CardText tag="h4">
                                <strong>User Id: </strong>
                                {activeUser.id.S}
                            </CardText>
                        </CardBody>
                        <CardBody>
                            <CardText tag="h4">
                                <strong>Api Key: </strong>
                                {activeUser.api_key.S}
                            </CardText>
                            <Input placeholder="New Api Key" value={apiInput} hidden={!editApi} onChange={(e) => setApiInput(e.target.value)} />
                            {editApi ? (
                                <Row className="mt-3">
                                    <Col sm={6}>
                                        <Button className="m-1" color="primary" onClick={() => handleSubmit("api")}>
                                            Update
                                        </Button>
                                        <Button className="m-1" onClick={() => handleEdit("api")}>
                                            Cancel
                                        </Button>
                                    </Col>
                                </Row>
                            ) : (
                                <Button onClick={() => handleEdit("api")}>Edit</Button>
                            )}
                        </CardBody>
                        <CardBody>
                            <CardText tag="h4">
                                <strong>Paid Level: </strong>
                                {activeUser?.paid?.S || 0}
                            </CardText>
                            <Input
                                placeholder="New Paid Level (only (0 to 6) allowed)"
                                value={paidInput}
                                hidden={!editPaid}
                                onChange={(e) => setPaidInput(e.target.value)}
                            />
                            {editPaid ? (
                                <Row className="mt-3">
                                    <Col sm={6}>
                                        <Button color="primary" className="m-1" onClick={() => handleSubmit("paid")}>
                                            Update
                                        </Button>
                                        <Button className="m-1" onClick={() => handleEdit("paid")}>
                                            Cancel
                                        </Button>
                                    </Col>
                                </Row>
                            ) : (
                                <Button onClick={() => handleEdit("paid")}>Edit</Button>
                            )}
                        </CardBody>
                        <CardBody>
                            <CardText tag="h4">
                                <strong>Credit Balance: </strong>
                                {activeUser.credit_balance.N}
                            </CardText>
                            <Input
                                type="number"
                                placeholder="Amount to Add or Sub"
                                min={0}
                                value={balanceInput}
                                hidden={!editBalance}
                                onChange={(e) => setBalanceInput(e.target.value)}
                            />
                            {editBalance ? (
                                <Row className="mt-3">
                                    <Col sm={6}>
                                        <Button
                                            className="m-1"
                                            color="primary"
                                            onClick={() => handleSubmit("balance_add")}
                                            disabled={!balanceInput > 0 || isLoading}
                                        >
                                            Add Credits
                                        </Button>
                                        <Button
                                            className="m-1"
                                            color="primary"
                                            onClick={() => handleSubmit("balance_sub")}
                                            disabled={!balanceInput > 0 || isLoading}
                                        >
                                            Remove Credits
                                        </Button>
                                        <Button onClick={() => handleEdit("balance")}>Cancel</Button>
                                    </Col>
                                </Row>
                            ) : (
                                <Button onClick={() => handleEdit("balance")}>Add / Sub Credits</Button>
                            )}
                        </CardBody>
                        <CardBody>
                            <CardText tag="h4">
                                <strong>Origin: </strong>
                                {activeUser.origin.S}
                            </CardText>
                            <Input
                                placeholder="New Origin ( something like: https://app.idexo.io )"
                                value={originInput}
                                hidden={!editOrigin}
                                onChange={(e) => setOriginInput(e.target.value)}
                            />
                            {editOrigin ? (
                                <Row className="mt-3">
                                    <Col sm={6}>
                                        <Button className="m-1" color="primary" onClick={() => handleSubmit("origin")}>
                                            Update
                                        </Button>
                                        <Button className="m-1" onClick={() => handleEdit("origin")}>
                                            Cancel
                                        </Button>
                                    </Col>
                                </Row>
                            ) : (
                                <Button onClick={() => handleEdit("origin")}>Edit</Button>
                            )}
                        </CardBody>
                        <CardBody>
                            <CardText tag="h4">
                                <strong>Inserted: </strong>
                                {Date(activeUser.inserted.N)} {/* Inserted: {activeUser.inserted.N} */}
                            </CardText>
                        </CardBody>
                        <CardBody>
                            <CardText tag="h4">
                                <strong>Ip: </strong>
                                {activeUser.ip.S}
                            </CardText>
                        </CardBody>
                        <CardFooter>
                            <Button onClick={getBalanceHistory}>Get Balance History</Button>
                        </CardFooter>
                    </Card>
                ) : null}
            </Card>

            <hr></hr>
            <div className="content">
                <pre id="output"></pre>
            </div>
        </div>
    )
}

export default Admin
